
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'; // Make sure this CSS is imported

// One stat on the dashboard: an icon tile, the number, what it counts, and a
// "View" link when it leads somewhere. With `total`, it also shows "of N" and
// a bar for how much of the total is done.
const ScoreCard = ({
  title,
  value,
  total,
  icon,
  tone = "primary",   // primary | warning | success: colours the icon tile
  linkLabel = "View",
  redirectPath,
  dataLoading,
  children,           // replaces the number, for cards that are a shortcut
}) => {
  const navigate = useNavigate();
  const isClickable = !!redirectPath;
  const go = () => isClickable && navigate(redirectPath);

  const hasTotal = total !== undefined && total !== null && total !== "" && Number(total) > 0;
  const donePct = hasTotal ? Math.round(((Number(total) - Number(value)) / Number(total)) * 100) : 0;

  return (
    <div
      className={`dashboard__card stat-card ${isClickable ? 'clickable' : ''}`}
      onClick={go}
      onKeyDown={(e) => isClickable && (e.key === 'Enter' || e.key === ' ') && go()}
      role={isClickable ? 'link' : undefined}
      tabIndex={isClickable ? 0 : undefined}
    >
      <div className="stat-card__top">
        <span className={`stat-card__icon tone-${tone}`} aria-hidden="true">{icon}</span>
        <span className="stat-card__title">{title}</span>
      </div>

      <div className="stat-card__body">
        {dataLoading ? (
          <Skeleton width={70} height={34} />
        ) : children ? (
          children
        ) : (
          <>
            <span className="stat-card__value">{value || 0}</span>
            {hasTotal && <span className="stat-card__of">of {total}</span>}
          </>
        )}
      </div>

      {hasTotal && !dataLoading && (
        <div className="stat-card__progress" title={`${donePct}% done`}>
          <span style={{ width: `${donePct}%` }} />
        </div>
      )}

      {isClickable && <span className="stat-card__link">{linkLabel} →</span>}
    </div>
  );
};

export default ScoreCard;
